import { render, staticRenderFns } from "./CustomerPortal.vue?vue&type=template&id=13956009"
import script from "./CustomerPortal.vue?vue&type=script&lang=js"
export * from "./CustomerPortal.vue?vue&type=script&lang=js"
import style0 from "./CustomerPortal.vue?vue&type=style&index=0&id=13956009&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports